import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';

// ------------------ list IT-------
const getAllIT = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.inventory.internalTransfer + `${filter ? '?' + filter : ''}`);
    return data;
};

const GetAllITQuery = (filter) => {
    return useQuery(['ITlist', filter], () => getAllIT(filter));
};

// ------------------ Add IT-------
const addIT = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.inventory.internalTransfer, payload);
};

const AddITMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addIT, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('ITlist');
            toastMessage('success', 'Internal Transfer Created Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            toastMessage('error', desc || 'Server Error');
        }
    });
};

export { AddITMutation, GetAllITQuery };
